module.exports = __webpack_public_path__ + "img/Empanel-loading.7ecf2cee.gif";